import { useTranslation } from 'react-i18next';
import { useUIStore } from '@/stores';

/**
 * One line under the header that says what the current step is for.
 *
 * Only the guided entry shows it: the classic entry numbers its steps
 * differently and "Platzierung anpassen" forces the design step in
 * single-product mode, where the line would not describe what is on screen.
 */
export function StepHint() {
  const { t } = useTranslation();
  const currentStep = useUIStore((state) => state.currentStep);
  const creatorEntryMode = useUIStore((state) => state.creatorEntryMode);
  const singleProductMode = useUIStore((state) => state.singleProductMode);

  if (creatorEntryMode !== 'guided' || singleProductMode) return null;

  return (
    <p
      data-testid="step-hint"
      className="dc-step-hint shrink-0 bg-[var(--paper)] px-6 pt-4 text-sm text-[var(--ink-2)]"
    >
      {t(`creator.header.stepHints.${currentStep}`)}
    </p>
  );
}
